export const RESPONSE_CONFIG = 'RESPONSE_CONFIG';
export const RESPONSE_META = 'RESPONSE_METADATA';
export const RESPONSE_FAVORITES = 'RESPONSE_FAVORITES';
export const FAVORITE_ADD = 'FAVORITE_ADD';
export const FAVORITE_REMOVE = 'FAVORITE_REMOVE';
export const TRANSLATIONS = 'TRANSLATIONS';
export const PLAN_SELECTOR_TRANSLATIONS = 'PLAN_SELECTOR_TRANSLATIONS';
export const PLAN_SELECTOR_ASSET = 'PLAN_SELECTOR_ASSET';
export const PLAN_SELECTOR_OFFERS = 'PLAN_SELECTOR_OFFERS';
export const USERTYPE = 'USERTYPE';
export const SHOWMODAL = 'SHOWMODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const RESPONSE_ASSET = 'RESPONSE_ASSET';
export const GET_FOLLOWINGS = 'GET_FOLLOWINGS';
export const FOLLOWING_REMOVE = 'FOLLOWING_REMOVE';
export const FOLLOWING_ADD = 'FOLLOWING_ADD';
export const REQUEST_FOLLOWINGS = 'REQUEST_FOLLOWINGS';
export const CLEAR_FOLLOWINGS = 'CLEAR_FOLLOWINGS';
export const UNSUSCRIBE_CONFIRM = 'UNSUSCRIBE_CONFIRM';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const ERROR_NOT_CONTROLED = 'ERROR_NOT_CONTROLED';
export const ERROR_NOT_CONTROLED_CLEAR = 'ERROR_NOT_CONTROLED_CLEAR';
